var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.element)?_c('a',{staticClass:"btn btn-link p-1 text-left",attrs:{"href":"javascript:;"},on:{"click":_vm.onClick}},[[_vm._v(" "+_vm._s(_vm.$t('global.show_invoice'))+" ")]],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }